module.exports = __webpack_public_path__ + "static/media/27.68bcc61b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/27.png
// module id = 394
// module chunks = 0